<template>
  <!-- <div id="nota-label"> -->
  <div>
    <div style="width:390px; height: 540px;position: relative; box-sizing: border-box; margin: 0 auto; padding: 20px 15px; font-size: 12px;overflow: hidden;">
      <div style="width: 196px; border-bottom: 2px solid #000; padding-right: 0; position: relative; padding-bottom: 10px; display: inline-grid; min-height: 120px;">
        <span>{{ shipment.origin.name }}</span>
        <span>{{ shipment.origin.company }}</span>
        <span>{{ shipment.origin.street }}</span>
        <span>{{ shipment.origin.neighborhood }}</span>
        <span>{{ shipment.origin.city }}</span>
        <span>{{ shipment.origin.state }}</span>
        <!-- <span>{{ shipment.origin.country_name }}</span> -->
        <span>CP {{ shipment.origin.postal_code }}</span>
        <span>TEL {{ shipment.origin.phone }}</span>
      </div>
      <div style="border-left: 2px solid #000; border-bottom: 2px solid #000; position: absolute; right: 0; width: 178px; padding: 0px 10px; min-height: 144px;  top: 30px;">
        <div style="position: relative; top: -18px; display: inline-grid;">
          <span><strong>{{ this.shipment.generated_label.created_at | date('lll') }}</strong></span>
          <span>{{ `${this.shipment.parcel.weight} kg` }}</span>
          <span>
            {{ `(${this.shipment.parcel.length} cm x ${this.shipment.parcel.width} cm x ${this.shipment.parcel.height} cm)` }}
          </span>
          <span>{{ this.shipment.rate.service.carrier.name.toUpperCase() }}</span>
          <span v-if="this.shipment.parcel.declared_tax_value">
            {{ this.shipment.parcel.declared_tax_value | currency }}
          </span>
          <p style="padding-bottom: 0; margin-bottom: 0;">
            {{ this.shipment.destination.reference }}
          </p>
        </div>
      </div>
      <div style="position: relative; left: 0;  top: 0; width: 195px; display: grid; margin-top: 10px; height: auto; float: left;">
         <span><strong>DESTINATARIO</strong></span>
        <span>{{ shipment.destination.name }}</span>
        <span>{{ shipment.destination.company }}</span>
        <span>{{ shipment.destination.street }}</span>
        <span>{{ shipment.destination.neighborhood }}</span>
        <span>{{ shipment.destination.city }}</span>
        <span>{{ shipment.destination.state }}</span>
        <span>{{ shipment.destination.country_name }}</span>
        <span>CP {{ shipment.destination.postal_code }}</span>
        <span>TEL {{ shipment.destination.phone }}</span>
      </div>
      <div style="position: absolute;border: 1px solid #000;right: 30px;top: 195px;text-align: center;width: 130px;padding: 10px 0;height: 100px;">
         <div style="width: 50%; height: 55px; margin: 0 auto; margin-bottom: 10px;">
            <!-- <img src="https://image.shutterstock.com/image-photo/word-demo-appearing-behind-torn-260nw-1782295403.jpg" style="width: 100%; height: 55px;"> -->

            <img :src="this.appLogo" style="width: 100%; height: 55px;">
         </div>
         <p style="padding: 0;">{{ company }}</p>
      </div>
      <div style="width: 150px;height: 80px;position: absolute;background: #ccc;top: 330px;">
        <img id="barcode" style="width: 100%; height: 80px"></img>
      </div>
      <div style="position: absolute; top: 416px; width: 150px;text-align: center;">
        {{ this.shipment.rate.service_name.toUpperCase() }}<br>
        <span v-if="this.shipment.rate.days && this.shipment.rate.days > 0">
          Tiempo de Transito<br>
          {{ `${ this.shipment.rate.days } DIAS HABILES` }}
        </span>
      </div>
      <div style="position: absolute; top: 470px; width: 105px; text-align: center;">
        COSTO: {{ shipment.rate.total | currency }}
      </div>
      <div style="position: absolute; top: 492px; width: 164px; text-align: left; left: 24px;">
        FIRMA DE CONFORMIDAD</div>
      <div style="position: absolute; top: 330px; width: 155px; text-align: left; right: 0;">NUMERO DE GUIA</div>
      <div style="position: absolute; top: 360px; width: 160px; text-align: left; right: 0; font-size: 22px;">
         <!-- <strong>7756 4089 3866</strong> -->
        <strong>{{ this.shipment.generated_label.tracking_number }}</strong>
      </div>
      <div style="position: absolute; top: 388px; width: 155px; text-align: left; right: 0;">
         SU ENVIO VIAJO POR:
      </div>
      <div style="position: absolute; top: 420px; width: 155px; text-align: left; right: 0; font-size: 22px;">
        <!-- <strong>FEDEX</strong> -->
        <strong>{{ this.shipment.rate.service.carrier.provider.name }}</strong>
      </div>
      <div style="width: 92%; border-bottom: 2px solid #000; position: absolute; top: 518px;"></div>
      <div style="width: 92%; position: absolute; top: 525px; text-align: center; font-size: 12px;">
        <strong>
          {{ appUrl }}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
var JsBarcode = require( 'jsbarcode' );
import Shipment from '@/client/shipment'

export default {
  name: 'NotaLabelPdf',

  props: {
    shipment: {
      type: Object,
      required: true
    },
    fiscalDatum: {
      type: Object,
      required: false
    },
    isAppLogo: {
      type: Boolean,
      required: true
    },
    termsConditionsLink: {
      type: String,
      required: false
    },
    appLogo: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      appColor: process.env.VUE_APP_COLOR,
      appName: process.env.VUE_APP_COMPANY,
      appUrl: ''
    }
  },

  components: {
  },

  computed: {
    appLogoPresent () {
      return !this.isAppLogo
    }
  },

  methods: {
    shipmentPackage () {
      return `(${this.shipment.parcel.length} cm x ${this.shipment.parcel.width} cm x ${this.shipment.parcel.height} cm) x ${this.shipment.parcel.weight} kg`
    }
  },

  watch: {
  },

  async mounted () {
    JsBarcode("#barcode", this.shipment.generated_label.tracking_number, { displayValue: false });
    this.appUrl = window.location.host
  }
}
</script>

<style scoped>
</style>
